import { useCallback } from 'react';

import { Loading, useListContext } from 'react-admin';

import Divider from '@mui/material/Divider';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { BPErrorView } from 'shared/components/common/BPErrorView.component';
import { getSummaryLabel } from 'shared/components/summary/getSummaryLabel';
import { ResourceName } from 'shared/enums/resource-name.enum';
import { useBPSummary } from 'shared/hooks/useBPSummary';
import { Stat } from 'shared/models/summary/Stat.model';

import { UsersDatagrid } from './UsersDatagrid.component';
import { AppUser } from '../models/AppUser.model';

export function UsersTabbedDatagrid() {
  const listContext = useListContext<AppUser>();
  const { filterValues, setFilters, displayedFilters } = listContext;

  const summary = useBPSummary(ResourceName.USERS);
  const tabs: Stat[] = [
    ...summary.data,
    new Stat(
      'all',
      'memberhsip_status',
      'All',
      summary.data.reduce((prev, { count }) => +prev + Number(count ?? 0), 0),
      'All'
    )
  ];

  const handleTabChange = useCallback(
    (value: string) => {
      setFilters &&
        setFilters(
          { ...filterValues, membership_status: value },
          displayedFilters,
          false // no debounce, we want the filter to fire immediately
        );
    },
    [displayedFilters, filterValues, setFilters]
  );

  return (
    <>
      {tabs && (
        <Tabs
          variant='fullWidth'
          centered
          value={filterValues.membership_status ?? 'All'}
          indicatorColor='primary'
          onChange={(e, value) => handleTabChange(value)}
        >
          {tabs.map((choice) => (
            <Tab
              key={choice.id}
              label={getSummaryLabel(choice.display_name, choice.count)}
              value={choice.filter_value}
            />
          ))}
        </Tabs>
      )}
      <Divider />
      {listContext.loading ? (
        <Loading />
      ) : listContext.error ? (
        <BPErrorView error={listContext.error} />
      ) : (
        <UsersDatagrid />
      )}
    </>
  );
}
